import React, { useState, useEffect } from "react";
import axios from "axios";
import $ from "jquery";
import "datatables.net-dt/js/dataTables.dataTables.js";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link } from "react-router-dom";
import { format } from "date-fns";
import { API_URL } from "../utils/api";
import { ToastContainer, toast } from "react-toastify";

const PricesLayer = () => {
  const [posts, setPosts] = useState([]);
 const [statuschanged, setStatuschanged] = useState(false);
     
  useEffect(() => {
    // Fetch data
    axios
      .get(process.env.REACT_APP_API_BASE_URL+"price-list")
      .then((response) => {
        setPosts(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [statuschanged]);


  const [servicesList, setServicesList] = useState([]);
  const [locationsList, setLocationsList] = useState({
    1:"Liverpool, NSW",
    2:"Drummoyne, NSW"
  });
 
  useEffect(() => {

     // Fetch data
     axios.get(process.env.REACT_APP_API_BASE_URL+"service-list")
     .then(response => {
        const servicedata = response.data.data;
        let servicearray = [];
        
        servicedata.map((srvc, index)=>(
            servicearray[srvc.id] = srvc.title
        ))
        setServicesList(servicearray);

     })
     .catch(error => {
         console.error('Error fetching data:', error);
     });
    // Initialize DataTable after posts are rendered
    if (posts.length > 0) {
      const table = $("#dataTable").DataTable({
        pageLength: 10,
      });

      // Cleanup function
      return () => {};
    }

  }, []); // Re-run this effect when posts change
  const formatDate = (dateString) => {
    return format(new Date(dateString), "dd-MM-yyyy");
  };
  const deleteStaff = async (id) => {
    if(window.confirm("Are you sure want to delete this Price Record?")) {
      axios
        .get(process.env.REACT_APP_API_BASE_URL+"price-delete/" + id)
        .then(async (res) => {
          toast.success("Record deleted sucessfully!!");
          setStatuschanged(!statuschanged);
           
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
  return (
    <div className="card basic-data-table">
      <div className="card-header">
        <h5 className="card-title mb-0"></h5>
      </div>
      <ToastContainer></ToastContainer>
      <div className="card-body">
        <table
          className="table bordered-table mb-0"
          id="dataTable"
          data-page-length={10}
        >
          <thead>
            <tr>
              <th scope="col">
                <div className="form-check style-check d-flex align-items-center">
                  <label className="form-check-label">S.L</label>
                </div>
              </th>
              <th scope="col">Location</th>
              <th scope="col">Group Name</th>
              <th scope="col">Services</th>
              <th scope="col">Price</th>
              <th scope="col">Comment</th>
              <th scope="col">Created Date</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            {posts.map((post, i) => (
              <tr key={"staff" + i}>
                <td>
                  <div className="form-check style-check d-flex align-items-center">
                    <label className="form-check-label">{i + 1}</label>
                  </div>
                </td>
                <td>{locationsList[post.location]}</td>
                <td>{post.group_name}</td>
                <td>{servicesList[post.service_id]}</td>
                <td>$.{post.price}</td>
                <td>{post.comments}</td>
                <td>{formatDate(post.createdAt)}</td>
                <td>
                  <Link
                    to={'/'+JSON.parse(localStorage.getItem('activeUser')).user_type+`/price-edit/${post.id}`}
                    className="w-32-px h-32-px me-8 bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
                  >
                    <Icon icon="lucide:edit" />
                  </Link>
                  <Link
                    onClick={() => deleteStaff(post.id)}
                    className="w-32-px h-32-px me-8 bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center"
                  >
                    <Icon icon="mingcute:delete-2-line" />
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PricesLayer;
